export default __webpack_public_path__ + "static/media/DarkBlue0001.3c5e7861.png";